// src/serviceWorkerRegistration.js
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { enviarPushSubscription } from './api/apiService';

// 🔑 Substitua por sua chave pública VAPID gerada anteriormente
const publicVapidKey = "BPcREBiXGn63CwwHL2TOJsNnchI6GS8vwXTR5Gt59HttUIo_pZtTRDFx8_I5FA2kHiT-9Nd5nqwrzUB-w2dsNYw"; 

export function register(config) {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

      navigator.serviceWorker
        .register(swUrl)
        .then((registration) => {
          console.log('Service Worker registrado com sucesso:', registration);

          // Solicitar permissão para notificações push
          askNotificationPermission(registration);

          registration.onupdatefound = () => {
            const installingWorker = registration.installing;
            if (installingWorker == null) return;

            installingWorker.onstatechange = () => {
              if (installingWorker.state === 'installed') {
                if (navigator.serviceWorker.controller) {
                  console.log('Nova atualização disponível!');
                  if (config && config.onUpdate) {
                    config.onUpdate(registration);
                  } else {
                    showUpdateNotification();
                  }
                } else {
                  console.log('Conteúdo está em cache para uso offline.');
                  if (config && config.onSuccess) {
                    config.onSuccess(registration);
                  }
                }
              }
            };
          };
        })
        .catch((error) => {
          console.error('Erro ao registrar o Service Worker:', error);
        });
    });
  }
}

function showUpdateNotification() {
  toast.info("Uma nova versão está disponível. Atualizando automaticamente...", {
    position: "top-center",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  });

  setTimeout(() => {
    window.location.reload();
  }, 3000);
}

async function askNotificationPermission(registration) {
  if (Notification.permission === 'granted') {
    console.log("Permissão para notificações já concedida.");
    await subscribeToPushNotifications(registration);
  } else if (Notification.permission !== 'denied') {
    const permission = await Notification.requestPermission();

    if (permission === 'granted') {
      console.log("Permissão para notificações concedida.");
      await subscribeToPushNotifications(registration);
    } else {
      console.log("Permissão para notificações negada.");
    }
  }
}

 // Importando a função
 async function subscribeToPushNotifications(registration) {
  try {
    const subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(publicVapidKey)
    });

    // 🔥 Enviar para o backend
    await enviarPushSubscription(subscription);

    console.log('Usuário inscrito para notificações push.');
  } catch (error) {
    console.error('Erro ao se inscrever para notificações push:', error);
  }
}


function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}
  